import React, { useContext } from 'react'
import { Switch, Route } from 'react-router-dom'

import Understanding from './pages/Understanding'
import Calculators from './pages/Calculators'
import InsightGraphs from './pages/InsightGraphs'
import PremiumGoal from './pages/PremiumGoal'
import Overview from './pages/Overview'

import InsightGraphsSidebar from './pages/InsightGraphs/components/InsightGraphsSidebar'
import { SidebarToggle, MainContent } from '../../layouts/components/Structure'

import IpsaContext from '../../context/IpsaContext'

const Insights = () => {
    const { refreshUser } = useContext(IpsaContext)

    return (
        <>
            <SidebarToggle>
                <InsightGraphsSidebar />
            </SidebarToggle>
            <MainContent>
                <Switch>
                    <Route path="/insights" exact component={InsightGraphs} />
                    <Route path="/insights/goaltracker" component={InsightGraphs} />
                    <Route path="/insights/overview" component={Overview} />
                    <Route path="/insights/opportunity" component={Understanding} />
                    <Route
                        path="/insights/premiumgoal"
                        component={PremiumGoal}
                        onLeave={refreshUser()}
                    />
                    <Route path="/insights/calculator" component={Calculators} />
                </Switch>
            </MainContent>
        </>
    )
}

export default Insights
